// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  options: {},
  search: '',
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init (context, payload) {
    // Create BP element on the window
    window.bp = window.bp || function () {
      (window.bp.q = window.bp.q || []).push(arguments)
    }
    window.bp.l = 1 * new Date()

    // Insert a script tag on the top of the head to load bp.js
    const scriptElement = document.createElement('script')
    const firstScript = document.getElementsByTagName('script')[0]
    scriptElement.async = true
    scriptElement.src = 'https://pixel.barion.com/bp.js'
    firstScript.parentNode.insertBefore(scriptElement, firstScript)
    // window.barion_pixel_id = payload.pixelID
    window.bp('init', 'addBarionPixelId', 'BP-PumYzU6fXX-A6')
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
